import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider
  },
  props: {
    vid: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    note: {
      type: String,
      default: undefined
    },
    value: {
      type: null,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      innerValue: ""
    };
  },
  created: function () {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  watch: {
    innerValue(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val;
      }
    }
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.innerValue = !this.value;
      this.$emit("toggled", this.innerValue);
    }
  }
};